export default {
  title: 'Create ToDo',
  backButton: 'All ToDos',
};
